<template>
  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mb-36">
    <PageTitle v-bind:title="title" v-bind:admin="false" />

    <TheCoursesMenu v-bind:index="2" />

    <!-- <QuoteTest /> -->

    <h2 class="text-xl font-bold mt-8">Курсы в процессе прохождения</h2>

    <ErrorMessage v-if="errors.load" :error="errors.load" />

    <Loader v-if="loading" />

    <section
      v-else
      v-for="c in data.courses"
      v-bind:key="c.id"
      class="mt-8"
      aria-labelledby="applicant-information-title"
    >
      <div class="bg-white shadow sm:rounded-lg">
        <div
          class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-pink-500"
        >
          <div class="flex-shrink-0">
            <img
              class="h-10 w-10 rounded-full"
              src="/icons/marker.png"
              alt=""
            />
          </div>
          <div class="flex-1 min-w-0">
            <router-link
              :to="{ name: 'course_show', params: { id: c.id } }"
              class="focus:outline-none"
            >
              <span class="absolute inset-0" aria-hidden="true"></span>
              <p class="text-sm font-medium text-gray-900">{{ c.name }}</p>
              <p class="text-sm text-gray-500 truncate">
                Курс пройден на
                {{
                  Math.round(
                    (100 * c.chapters_finished_count) / c.chapters_count
                  )
                }}%
              </p>
            </router-link>
          </div>
        </div>
        <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
          <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
            <div class="sm:col-span-1">
              <dt class="text-sm font-medium text-gray-500">Курс начат:</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ localeDate(c.pivot.started_at) }}
              </dd>
            </div>
            <div class="sm:col-span-1">
              <dt class="text-sm font-medium text-gray-500">Всего глав:</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ c.chapters_count }}
              </dd>
            </div>
            <div class="sm:col-span-1">
              <dt class="text-sm font-medium text-gray-500">Пройдено глав:</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ c.chapters_finished_count }}
              </dd>
            </div>
            <div v-if="c.next_chapter" class="sm:col-span-1">
              <dt class="text-sm font-medium text-gray-500">
                Следующая глава:
              </dt>
              <dd class="mt-1 text-sm text-gray-900">
                <router-link
                  :to="{
                    name: 'chapter_show',
                    params: { id: c.next_chapter.id },
                  }"
                  >{{ c.next_chapter.name }}</router-link
                >
              </dd>
            </div>
          </dl>
        </div>
        <div
          v-if="c.last_activity"
          class="block bg-gray-50 text-sm font-medium text-gray-500 text-center px-4 py-4 sm:rounded-b-lg"
        >
          Последняя активность:
          {{ localeDate(c.last_activity) }}
        </div>
      </div>
    </section>

    <!-- <div  class="card mt-3">
            <div class="card-header">
                <img src="/icons/marker.png" width="32px" alt="">
                Курс пройден на {{ Math.round(100 * c.chapters_finished_count / c.chapters_count) }}%
            </div>
            <div class="card-body">
                <h5 class="card-title">{{ c.name }}</h5>
                <p class="card-text">
                    <ul>
                        <li>Курс начат: <strong>{{ localeDate(c.pivot.started_at) }}</strong></li>
                        <li>Всего глав: <strong>{{ c.chapters_count }}</strong></li>
                        <li>Пройдено глав: <strong>{{ c.chapters_finished_count }}</strong></li>
                        <li v-if="c.next_chapter">
                            Следующая глава:
                            <router-link :to="{ name: 'chapter_show', params: { id: c.next_chapter.id } }">{{ c.next_chapter.name }}</router-link>
                        </li>
                    </ul>                    
                </p>
                <router-link class="btn btn-primary" :to="{ name: 'course_show', params: { id: c.id } }">Перейти к курсу</router-link>
            </div>
            <div class="card-footer text-muted">
                <template v-if="c.last_activity">
                    Последняя активность:
                    {{ localeDate(c.last_activity) }}
                </template>
            </div>
        </div> -->
  </div>
</template>

<script>
import TheCoursesMenu from "@/components/TheCoursesMenu";
import PageTitle from "@/components/PageTitle";
import Loader from "@/components/Loader";
import ErrorMessage from "@/components/ErrorMessage";
import axios from "axios";
// import QuoteTest from "@/components/QuoteTest";
export default {
  components: {
    ErrorMessage,
    TheCoursesMenu,
    PageTitle,
    Loader,
    // QuoteTest,
  },
  data() {
    return {
      data: [],
      title: "Курсы",
      errors: { load: "" },
      loading: true,
    };
  },
  async mounted() {
    // загрузка данных:
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("courses/inprogress");
        this.data = response.data;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
    localeDate(d) {
      // Конвертируем число в строку. Для этого существуют специальные методы
      // toLocaleDateString() или toLocaleString() или toLocaleTimeString()
      // Итоговая строка будет зависеть от локализации системы пользователя.
      // Для русской локали это будет "01.02.2020",
      // для американской "2/1/2020",
      // для немецкой — "1.2.2020"
      // Вы НЕ должны устанавливать формат даты самостоятельно
      if (d) return new Date(d).toLocaleDateString();
      else return null;
    },
  },
};
</script>
<style scoped>
ul li {
  /* border: 2px solid red; */
  list-style: none;
  background: url(/icons/arrow.png) no-repeat left 50%;
  padding-left: 25px;
}
</style>